import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FileService {
    auth = inject(AuthService);

    static Mode = {
        Ticket: 1,
        Invoice: 2,
        EmailMessage: 3,
        Customer: 4
    };
    static ImageExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];

    getUploadUrl(id: string | number, mode: number) {
        return `${environment.serviceName}/file/saveAttachment?id=${id}&mode=${mode}`;
    }

    getUploadHeader() {
        return { Authorization: `Bearer ${this.auth.currentUser.jwtToken}` };
    }

    parseUploadResponse(e: any) {
        if (!e || !e.request || !e.request.responseText) return { success: false, message: 'Could not handle upload response' };
        return JSON.parse(e.request.responseText) as { success: boolean; message?: string };
    }
}
